import { reatomBoolean } from '@reatom/framework'
import { withLocalStorage } from '@reatom/persist-web-storage'

import { STORAGE_PREFIX } from '@root/shared'

const STORAGE_KEY = `${STORAGE_PREFIX}/v1/isFlashDistinctEnabled`

export const isFlashTemporalDistinctEnabledAtom = reatomBoolean(
  true,
  'isFlashTemporalDistinctEnabledAtom',
).pipe(withLocalStorage(STORAGE_KEY))
